import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "src/store/hooks";

import { Image } from "antd";
import { selectPostEntities, selectPostIds } from "src/store/community/postsSlice";
import { selectUserEntities } from "src/store/community/usersSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids           = useAppSelector(selectPostIds);
  const posts  = useAppSelector(selectPostEntities);
  const users = useAppSelector(selectUserEntities);

  const renderSticker = (id: EntityId) => {
    const post = posts[id];

    if (!post) {
      return;
    }

    const user = post.user_id ? users[post.user_id] : undefined;

    return <Card post={post} user={user} key={`post-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderSticker)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
